'use strict';

const { h, Component } = require('phy');
const { hydrate } = require('@grpn/hydration');
const { Translate } = require('@grpn/preact-l10n');
const clipboard = require('clipboard-polyfill');

const textSelection = require('../../support/text-selection');

class RedemptionCode extends Component {
  constructor(props, ...rest) {
    super(props, ...rest);

    this.state = {
      copySuccess: false,
    };

    this.refs = {
      value: null,
    };

    this.clickHandlerCopy = this.clickHandlerCopy.bind(this);
  }

  render({ offerCode }) {
    return (
      offerCode &&
      h('.redemption-code', [
        h(
          'a.redemption-code-button',
          {
            onClick: this.clickHandlerCopy,
            'data-bhw': 'coupon:copy',
          },
          this.getCopyText()
        ),
        h(
          'span.redemption-code-value',
          { ref: el => (this.refs.value = el) },
          offerCode
        ),
      ])
    );
  }

  getCopyText() {
    const { copySuccess } = this.state;

    const key = copySuccess ? 'Copied' : 'Copy';

    return h(Translate, `js.modules.redemption.${key}`);
  }

  clickHandlerCopy() {
    const { offerCode } = this.props;
    const { value } = this.refs;

    textSelection(value);

    clipboard.writeText(offerCode);

    this.setState({
      copySuccess: true,
    });
  }
}

module.exports = hydrate('RedemptionCode', RedemptionCode);
